import React, { PropsWithChildren } from "react";

import { Container, Fade } from "@mui/material";

/**
 * Layout of a page
 */
export const PageLayout = ({ children }: PropsWithChildren<unknown>) => (
  <Fade in={true}>
    <Container sx={{ py: 3 }}>{children}</Container>
  </Fade>
);
